import { isReactNative } from 'ui-builder';
import WebLayout from './SmsFieldLayout.web';
import MobileLayout from './SmsFieldLayout.mobile';

export default isReactNative() ?  MobileLayout : WebLayout;
